export enum TimelineActionEnum {
	UPDATE = "UPDATE",
	INSERT = "INSERT",
	DELETE = "DELETE",
}
